import React, { useState, useEffect } from 'react';
import "styles/common.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Container } from "components/Layout";
import Header from "components/Header";
import Footer from "components/Footer";
import PageMeta from "components/PageMeta";
import Home from "pages/Home";
import PlatformOverview from "pages/PlatformOverview";
import SmallMoleculeDrugs from "pages/SmallMoleculeDrugs";
import PeptideBasedDrugs from "pages/PeptideBasedDrugs";
import BBBPrediction from "pages/BBBPrediction";
import Partnerships from "pages/Partnerships";
import Membership from "pages/Membership";
import RequestQuote from "pages/RequestQuote";
import Contact from "pages/Contact";
import CompanyOverview from "pages/CompanyOverview";
import Technologies from "pages/Technologies";
import IntellectualProperty from "pages/IntellectualProperty";
import Services from "pages/Services";
import NewsPage from "pages/NewsPage";
import Publications from "pages/Publications";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check for saved theme preference or default to system preference
    const savedTheme = localStorage.getItem('preferred-theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    const initialTheme = savedTheme === 'dark' || (!savedTheme && systemPrefersDark);

    if (initialTheme) {
      document.documentElement.classList.add('dark-mode');
    }
    setIsDarkMode(initialTheme);
  }, []);

  // This function will sync with the external toggle
  const syncWithExternalToggle = () => {
    const isNowDark = document.documentElement.classList.contains('dark-mode');
    setIsDarkMode(isNowDark);
  };

  // Periodically check for theme changes (fallback for external toggle)
  useEffect(() => {
    const interval = setInterval(syncWithExternalToggle, 1000);
    return () => clearInterval(interval);
  }, []);

  const toggleTheme = () => {
    const root = document.documentElement;
    const isDark = root.classList.toggle('dark-mode');
    localStorage.setItem('preferred-theme', isDark ? 'dark' : 'light');
    setIsDarkMode(isDark);

    // Update the external toggle button if it exists
    const externalToggle = document.getElementById('theme-toggle');
    if (externalToggle) {
      externalToggle.innerText = isDark ? '☀️ Light Mode' : '🌙 Dark Mode';
    }
  };

  return (
    <div className="app">
      <Router>
        <PageMeta />
        <Header />
        <Container>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/platform-overview" element={<PlatformOverview />} />
            <Route path="/technologies" element={<Technologies />} />
            <Route path="/intellectual-property" element={<IntellectualProperty />} />
            <Route path="/small-molecule-drugs" element={<SmallMoleculeDrugs />} />
            <Route path="/peptide-based-drugs" element={<PeptideBasedDrugs />} />
            <Route path="/bbb-prediction" element={<BBBPrediction />} />
            <Route path="/publication" element={<Publications />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:slug" element={<NewsPage />} />
            <Route path="/partnership" element={<Partnerships />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/request-quote" element={<RequestQuote />} />
            <Route path="/company-overview" element={<CompanyOverview />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Container>
        <Footer />
      </Router>

      {/* Optional: React-based theme toggle button (alternative to the external one) */}
      {/* Uncomment if you want to use React component instead of external script */}
      <button
        className="btn btn-secondary theme-toggle-react"
        onClick={toggleTheme}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: '9999'
        }}
      >
        {isDarkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
      </button>

    </div>
  );
}

export default App;
